module.exports = __webpack_public_path__ + "static/img/Blank product screen w_ shadow.4ff00ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/Blank product screen w_ shadow.png
// module id = sYG0
// module chunks = 0